export enum TIER_NUMBERS {
  FOREVER = 0,
  LIMITED = 1,
}

export enum TIERS {
  FOREVER = 'forever',
  LIMITED = 'limited',
}

export function getTierForNumber(tierNumber: number | null): TIERS | undefined {
  if (tierNumber === null) return;

  return {
    [TIER_NUMBERS.FOREVER]: TIERS.FOREVER,
    [TIER_NUMBERS.LIMITED]: TIERS.LIMITED,
  }[tierNumber];
}
